import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Form, Button, Table, InputGroup, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function ProductListPage() {
    const [category, setcategory] = useState([]);
    const [subcategory, setSubcategory] = useState([]);
    const [categoryId, setCategoryId] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');

    const [data, setdata] = useState([]);

    const [isDownload, setDownload] = useState(false);
   
    const fetchGroups = async () => {
        try {
            debugger;
            const response = await adminInstance.get("subgroup/GetMaster");
            setcategory(response.data.groups);
            setSubcategory(response.data.subGroups);
            setdata(response.data.subGroups);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const loadSubCategory = () => {
        var subGroups = categoryId == 0 ? subcategory : subcategory.filter(s => s.GroupId == categoryId);
        debugger;
        setdata(subGroups);
    }

    const navigate = useNavigate();
    
    const handleViewProduct = (subGroupId) => {
        navigate(`/Product/${subGroupId}`);
    }

    const handleEdit = (subGroupId) => {
        navigate(`/ManageProduct/${subGroupId}`);
    }

    const handleNewProduct = () => {
        navigate('/ManageProduct');
    }

    const handleProductFiles = (subGroupId) => {
        navigate(`/ProductFiles/${subGroupId}`);
    }

    const handleProductImages = (subGroupId) => {
        navigate(`/ProductImages/${subGroupId}`);
    }
    
    const filteredData = data
    .filter(spare =>
      spare.SubGroupName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.SubGroupCode?.toLowerCase().includes(searchTerm.toLowerCase()) || 
      spare.GroupName?.toLowerCase().includes(searchTerm.toLowerCase()) 
    );

    useEffect(() => {
        fetchGroups();        
    }, []);

    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <h4>
                            Product Master
                        </h4>
                    </div>
                    <div className="card-body aon-card-body">
                        <div class="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    {/* <label>Select Category</label> */}
                                    <select
                                        className="form-control sf-form-control"
                                        value={categoryId}
                                        onChange={(e) => setCategoryId(e.target.value)}
                                    >
                                        <option value="">Select Category</option>
                                        {category && category.length > 0 && category?.map((item) => (
                                            <option key={item.GroupCode} value={item.GroupCode}>
                                                {item.GroupName}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <button className="admin-button wid-200" onClick={() => loadSubCategory()} style={{marginRight:20}}>
                                    Load
                                </button>

                                <button className="admin-button wid-200" onClick={() => handleNewProduct()}>
                                    + New Product
                                </button>
                            </div>
                        </div>
                        {
                            <div className="sf-bs-data-table">
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table responsive" style={{ width: '100%'}}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                {/* <th>Image</th> */}
                                                <th>Category</th>
                                                <th>Part Number</th>
                                                <th>Product Name</th>
                                                <th>Description</th>
                                                <th>Status</th>
                                                <th>Action</th>                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr >
                                            <td colSpan={7}>
                                            <InputGroup className="mb-3">
                                            <Form.Control
                                                placeholder="Search product..."
                                                value={searchTerm}
                                                onChange={e => setSearchTerm(e.target.value)}
                                            />
                                            </InputGroup>
                                            </td>
                                        </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{index + 1}</td>
                                                            {/* <td>{emp.Img}</td> */}
                                                            <td>{emp.GroupName}</td>
                                                            <td>{emp.SubGroupCode}</td>
                                                            <td>{emp.SubGroupName}</td>
                                                            <td>{emp.Description}</td>
                                                            <td>{emp.IsActive ? <Badge bg="success">Active</Badge> : <Badge bg="danger">Inactive</Badge>}</td>
                                                            <td>
                                                                <button className="admin-button wid-200" onClick={() => handleEdit(emp.SubGroupId)} style={{marginRight:20}}>Edit</button>
                                                                <button className="admin-button wid-200" onClick={() => handleProductFiles(emp.SubGroupId)} style={{marginRight:20}}>Files</button>
                                                                <button className="admin-button wid-200" onClick={() => handleProductImages(emp.SubGroupId)} style={{marginRight:20}}>Images</button>
                                                                {/* <button className="admin-button wid-200" onClick={() => handleViewProduct(emp.SubGroupId)}>View</button> */}
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                          }                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </>
    );
}

export default ProductListPage;
